<template>
  <div class="pt-5 pb-15 px-5 d-flex flex-column align-center justify-start gap-14 h-full">
    <v-btn v-if="fullscreen" class="close-preview" @click="closePreview" icon>
      <v-icon color="primary">mdi-close</v-icon>
    </v-btn>
    <div class="d-flex flex-column align-center gap-14">
      <div class="preview-title">{{$t('auth_preview_title')}}</div>
      <v-select
        v-model="screenPreview"
        :items="screenPreviewOptions"
        item-text="name"
        item-value="value"
        :label="$t('auth_preview_select_option')"
        solo
      ></v-select>
    </div>
    <div class="phone-ctn" :class="{ 'fullscreen': fullscreen }">
      <img src="@/assets/iphone-frame.png" alt="">

      <div class="phone-content">
        <PreviewScreen
          id="screen-preview"
          v-bind="getAppBrandingTheme"
        >
          <template v-slot="branding">
            <component
              :is="screenPreview === 'splash' ? 'SplashingScreen' : 'ScanningScreen'"
              v-bind="branding"
            />
          </template>
        </PreviewScreen>
      </div>
    </div>
    <div class="hint">{{$t('auth_preview_hint')}}</div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SplashingScreen from '@/components/authenticationPreview/SplashingScreen.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import ScanningScreen from '@/components/authenticationPreview/ScanningScreen.vue'

import stLogo from '../assets/st_logo.svg'

export default {
  name: 'AuthAppBrandingPreview',
  components: { ScanningScreen, PreviewScreen, SplashingScreen },
  props: ['fullscreen'],
  data () {
    return {
      screenPreview: 'splash',
      screenPreviewOptions: [
        { name: 'Splash Screen', value: 'splash' },
        { name: 'Scanning Screen', value: 'scanning' }
      ]
    }
  },
  computed: {
    ...mapGetters(['remoteConfig', 'getAuthAppBranding']),
    getAppBrandingTheme () {
      const branding = this.getAuthAppBranding || {}
      return {
        logo: branding.logo || stLogo,
        backgroundColor: branding.background,
        primaryColor: branding.primary,
        secondaryColor: branding.secondary,
        overlayColor: branding.overlay
      }
    }
  },
  methods: {
    ...mapMutations({
      changePreviewMode: 'CHANGE_PREVIEW_MODE'
    }),
    closePreview () {
      this.changePreviewMode(false)
    }
  }
}
</script>

<style scoped lang="sass">
@import '@/variables.sass'
.gap-14
  gap: 14px

.preview-title
  font-size: 18px
  font-weight: 400
  color: #000000

.hint
  color: #000000
  font-size: 14px
  font-style: italic
  font-weight: 300

.close-preview
  position: absolute
  top: 10px
  right: 10px

.phone-ctn
  margin-left: auto
  margin-right: auto
  width: 294px
  height: 610px
  min-height: 607px
  &.fullscreen
    .phone-content
      top: 0
      bottom: 0

  border-radius: 30px
  z-index: 0
  position: relative
  overflow: hidden
  margin-top: 7px
  @include xl
    width: 320px
    height: auto
    min-height: 657px
    border-radius: 48px

  img, #screen-preview
    position: relative
    width: 100%
    height: 100%
    z-index: 20

  .phone-content
    position: absolute
    top: 0
    bottom: 0
    left: 15px
    right: 15px
    z-index: 15

</style>
